<template lang="pug">
	.creative-versions(v-if="creative" :style="{'height': `calc(100% - ${Layout.subHeaderHeight}px)`, 'top': `${Layout.subHeaderHeight}px`, 'left': `${Layout.getCreativesPlaneWidth()}px`}")
		.p-3.creative-settings-header(v-if="creative")
			.caption
				span(v-if="")
					.ready(v-if="creative.type === 'playable'") Playable
					.ready(v-if="creative.type === 'banner'") Banner
					.ready(v-if="creative.type === 'end-card'") End Card
					.ready(v-if="creative.type === 'storyboard'") Storyboard
					.ready(v-if="creative.type === 'editable-playable'") AI Playable
				span {{creative.title}}
				CreativeActions
				//span(v-if="User.currentUser.Tags['admin'] && creative.type === 'playable'")
					.in-development(v-if="!creative.Tags['released']") Separated js files
					.ready(v-if="creative.Tags['released']") Combined js files
				VersionFilter
		.creative-settings-wrapper(v-bar :style="{'height': `calc(100% - ${Layout.headerHeight + Layout.subHeaderHeight}px - 37px)`}")
			.creative-settings-inner
				.creative-version-list(v-if="Creative.isSelectedCreativeLoaded()")
					.creative-version(v-if="!version.Tags['hidden'] || isShowHiddenVersions" v-for="version in versions" :class="{base: version.Tags.base, custom: !version.Tags.base}")
						.creative-version-title-wrapper(:class="{selected: Version.SelectedVersion && Version.SelectedVersion.id === version.id}" @click="Version.selectVersion(version.id)")
							.creative-version-title(:title="getVersionTitle(version)")
								i.fa.fa-lock(v-if="version.Tags.base && (creative.type === 'playable' || creative.type === 'end-card')")
								span {{getVersionTitle(version)}}
						.creative-version-online(v-if="Layout.isFeatureEnabled('online-users', 'online-users-version-plane')")
							OnlineUsersLocal(:filter="getFilterForOnlineUsers(version.id)" max-count="5")
						.creative-version-edit-wrapper(:class="{selected: Version.SelectedVersion && Version.SelectedVersion.id === version.id}" @click="editVersionSettings(version)")
							.creative-version-edit
								i.fa.fa-gear
				.archived-settings(v-if="Settings.isHiddenVersions() && !isShowHiddenVersions")
					button.btn.btn-outline-secondary(@click="isShowHiddenVersions = true")
						.archived-settings-title Show hidden versions
				.archived-settings(v-if="Settings.isHiddenVersions() && isShowHiddenVersions")
					button.btn.btn-outline-secondary(@click="isShowHiddenVersions = false")
						.archived-settings-title Hide hidden versions
				.add-version(v-if="creative.type === 'banner' || creative.type === 'end-card' || creative.type === 'storyboard' || creative.type === 'editable-playable'")
					.version-add-icon(v-on:click="addVersion()" v-b-tooltip.hover="{delay: { show: 1500, hide: 100 }, title: 'Create version'}")
						i.fa.fa-plus

</template>

<script>

	import Screen 				from './../../mixins/screen';

	import { User } 			from './../../services/User'
	import { Creative } 			from './../../services/Creative'
	import { Version } 			from './../../services/Version'
	import { Settings } 		from './../../services/Settings'
	import { Layout } 			from './../../services/Layout'

	import CreativeActions 		from './../Creative/CreativeActions'
	import VersionFilter 		from './../Version/VersionFilter'
	import OnlineUsersLocal		from './../Header/OnlineUsersLocal';

	export default {
		name: 'VersionsPlane',
		mixins: [Screen],
		screen: {
			updateOn: [
				"Layout Page Changed", //Меняется ширина creatives plane
				"Selected Publisher Changed",
				"Selected Version Switched",
				"Creative Fully Loaded",
				"Versions Filter Changed",
				"Current User Changed: [options.features]",
				"Users Online Status Changed",
				"User Online Status Changed",
				"User Online Status Added",
				"User Online Status Removed",
				"Selected Creative Renamed",
				"Selected Creative Tags Changed",
				"Selected Creative Version Added",
				"Selected Creative Version Changed: [title]",
				"Selected Creative Version Changed: [Tags.hidden]",
				"Selected Creative Version Removed"
			]
		},
		components: {
			CreativeActions,
			VersionFilter,
			OnlineUsersLocal
		},
		data() {

			this.User = User;
			this.Creative = Creative;
			this.Version = Version;
			this.Settings = Settings;

			this.creative = null;
			this.versions = [];

			return {
				showed: true,
				isShowHiddenVersions: false
			};

		},
		methods: {
			collectData() {

				this.creative = Creative.SelectedCreative;
				this.versions = [];

				if (this.creative) {

					let versions = _.values(Version.getVersionsByCreative(this.creative.id));

					if (this.creative.type === 'playable') {

						let baseVersions = _.sortBy(_.filter(versions, v => v.Tags.base), "create_date");
						let customVersions = _.sortBy(_.filter(versions, v => v.Tags.custom), "create_date");
						versions = [...baseVersions, ...customVersions];

					} else if (this.creative.type === 'banner' || this.creative.type === 'storyboard' || this.creative.type === 'editable-playable') {

						versions = _.sortBy(versions, "create_date");

					}

					if (Layout.versionsFilter) versions = _.filter(versions, v => v.title.toLowerCase().indexOf(Layout.versionsFilter.toLowerCase()) > -1 || v.codename.toLowerCase().indexOf(Layout.versionsFilter.toLowerCase()) > -1);

					this.versions = versions;

				}

			},
			editVersionSettings(version) {

				Broadcast.call("Show VersionSettings", [version.id]);

				Broadcast.call("Pseudo Modal Hide", ['creative-settings-options-dropdown']);

			},
			getFilterForOnlineUsers(versionId) {

				return userData => User.getLastActiveVersionData(userData).versionId === versionId;

			},
			addVersion() {

				if (this.creative.type === 'banner') {

					Broadcast.call("Show BannerCreateVersion");

				} else if (this.creative.type === 'storyboard') {

					Broadcast.call("Show StoryboardCreateVersion");

				} else if (this.creative.type === 'editable-playable') {

					Broadcast.call("Show EditablePlayableCreateVersion");

				} else {

					Server.sendToSocket({
						CreateVersion: {
							creativeId: Creative.SelectedCreative.id
						}
					});

				}

			},
			getVersionTitle(version) {

				if (this.creative.type === 'playable') {

					return version.codename || version.title;

				} else {

					return version.title || version.codename;

				}

			}
		}
	}
</script>

<style lang="sass">

	.creative-versions
		width: 250px
		height: 100%
		background-color: #3a4149
		border-right: 1px solid #23282c
		color: #f3f4f5
		text-align: left
		position: absolute
		left: 0
		top: 0
		z-index: 1
		transition: left 0.2s ease-in-out

		.creative-settings-header
			border-bottom: 1px solid #23282c

		.caption
			font-weight: 500
			cursor: default

			.in-development
				font-size: 0.775rem
				color: #f86c6b

			.ready
				font-size: 0.775rem
				color: #4dbd74

		.creative-settings-wrapper
			overflow-x: hidden
			overflow-y: auto

			&::-webkit-scrollbar
				position: fixed
				width: 10px
				margin-left: -10px
				-webkit-appearance: none
				appearance: none

			&::-webkit-scrollbar-track
				background-color: rgba(0, 0, 0, 0.2)

			&::-webkit-scrollbar-thumb
				height: 50px
				background-color: rgba(0, 0, 0, 0.2)
				background-clip: content-box
				border-color: transparent
				border-radius: 5px

		.creative-settings
			height: 48px
			display: flex
			align-items: center
			justify-content: left
			border-bottom: 1px solid #23282c
			cursor: pointer

			&:hover
				background-color: #2f353a

			&:active
				background-color: #f3f4f5
				color: #2f353a

			&.selected
				background-color: #20a8d8

		.archived-settings
			height: 56px
			display: flex
			justify-content: center
			white-space: nowrap
			align-content: center
			align-items: center

			button.btn.btn-outline-secondary
				height: 30px
				background-color: #3a4149
				color: #6d7a88
				border-color: #58636e
				padding: 0.25rem 0.4rem

				&:active
					color: #fff !important
					background-color: #656f7a !important

				&:hover
					background-color: #303539
					color: #fff

				&:focus
					box-shadow: none

				.archived-settings-title
					font-size: 12px

		.creative-version
			height: 48px
			display: flex
			justify-content: space-between
			border-bottom: 1px solid #23282c
			cursor: pointer
			position: relative

			&:hover
				background-color: #2f353a

			&:active
				background-color: #f3f4f5
				color: #2f353a

			.creative-version-title-wrapper
				display: flex
				flex-direction: row
				align-items: center
				flex: 1
				min-width: 0
				overflow: hidden

				&.selected
					background-color: #20a8d8

				.creative-version-title
					display: flex
					align-items: center
					width: 100%
					min-width: 0
					overflow: hidden
					padding: 0 1rem

					i
						flex-shrink: 0
						margin-right: 10px

					span
						overflow: hidden
						text-overflow: ellipsis
						white-space: nowrap
						min-width: 0

				.creative-version-title-hidden
					color: #8e8e8e
					padding: 0 1rem

			.creative-version-online
				position: absolute
				right: 2px
				bottom: 2px
				height: 15px
				width: 100%
				pointer-events: none

				.c-avatar-status
					display: none

				.online-users-local
					justify-content: right

			.creative-version-edit-wrapper
				display: flex
				flex-direction: row
				justify-content: center
				align-items: center
				flex-shrink: 0
				width: 0
				overflow: hidden

				&.selected
					background-color: #20a8d8

				&:hover
					color: #20a8d8

				&.selected:hover
					color: #23282c

				.creative-version-edit
					display: flex
					visibility: hidden
					padding: 0 1rem 0 1rem

		// Кнопка настроек версии показывается только при наведении - до этого момента название версии занимает всю строку
		.creative-version:hover

			.creative-version-title-wrapper

				.creative-version-title
					padding-right: 0

			.creative-version-edit-wrapper
				width: 20%

			.creative-version-edit
				visibility: visible

		.add-version
			display: flex
			justify-content: center
			align-items: center
			height: 50px

			.version-add-icon
				color: #f3f4f5
				width: 28px
				cursor: pointer

				&:hover
					color: #20a8d8

</style>

